export const TRANSLATIONS_EN = {

	//Login Page
	// welcome: "Welcome.",
	// subWelcome: "Manage your Data sharing with SGTraDex Pitstop.",
	makingTrade: "Making your trade data sharing easy and secure",
	enterUsernameAndPassword: "Enter your email and password to login",
	problemLoggedIn: "Problem logging in. Please try again.",
	login: "Welcome to SGTraDex Pitstop Portal",
	invalidcredentials:"Your email or password is incorrect.",

	//Text related to Pitstop
	shareData: "Share Data",
	cdiPitstop: "SGTraDex Pitstop",
	dataElement: "Data Element",
	na: "-NA-",
	myPitstop: "My Pitstop",
	simulateProvide: "Simulate Provide",
	simulateReceive: "Simulate Receive",
	provideData: "Provide Data",
	receiveData: "Receive Data",


	//General Text
	logout: "Logout",
	all: "All",
	pending: "Pending",
	success: "Success",
	sending: "Sending",
	sent: "Sent",
	received: "Received",
	failed: "Failed",
	expired: "Expired",
	pending_approval: "Pending Approval",
	rejected: "Rejected",
	destination: "Destination",
	onBehalfOf: "On Behalf Of",
	date: "Date",
	status: "Status",
	share: "Share",
	back: "Back",
	previous: "Previous",
	next: "Next",
	create: "Create",
	submit: "Submit",
	select: "Select",
	required: "Required",
	optional: "Optional",
	sender: "Sender",
	download: "Download",
	reset: "Reset",
	receive: "Receive",
	provide: "Provide",
	notify: "Notify",
	change: "change",
	confirm: "Confirm",
	edit: "Edit",
	store: "Store",
	push: "Push",
	pull: "Pull",
	transaction: "Transaction",
	forward: "Forward",
	export: "Export",


	//Input related
	requiredInput: "Required",

	//Sidebar Nav
	sharedData: "Shared Data",
	receivedData: "Received Data",
	recordtransfer: "Record Transfer",
	myActivities: "My Activities",
	eclipDataBundling: "Package Sharing",
	dataOrganizer: "Data Organizer (Alpha)",

	//Single Data Sharing Page
	singleDataSharing: "Single Data Sharing",

	//Shared Data Page
	notProviderError: "Based on your config, you are not providing any data elements.",
	filterByDataElement: "Filter By Data Element:",
	filterParticipants: "Participants:",
	filterStatus: "Status:",
	noRecordsFound: "No records found.",

	//Share Data Page
	chooseDataElement: "Choose Data Element",
	chooseParticipant: "Choose Participant",
	fillDataElements: "Fill Data Elements",
	selectedDataElements: "Selected Data Element",
	selectedParticipant: "Selected Participant",
	uploadedData: "Uploaded Data",
	uploadData: "Upload Data",
	downloadTemplates: "Download Templates",
	selectedDataElement: `Data Element Name`,
	downloadTemplateMessage: `Here are the templates you can use as reference for <bold>"{{selectedDataElement}}".</bold>`, // Here are the templates you can use as reference for "the selected data element"/"Bill of Lading".
	downloadTemplate: `<br>Please click and download <json>{{json}}</json> or <csv>{{csv}}</csv>.`, // Please click and download JSON Template or CSV Template.
	jsonTempalte: "JSON Template",
	csvTemplate: "CSV Template",
	chooseDataElementToShare: "Choose a data element to share:",
	chooseWhomToShare: "Choose whom you want to share your data with:",
	chooseWhoYouSend: "Choose who you would like to send this to",
	chooseWhoAccessData: "Choose who you want to have access to your data",
	chooseWhoYouWantToAccessData: "Choose who you want to have access to your data",

	//Attachment
	uploadYourData: "Upload your data",
	dropData: "Drop your data file or ",
	browse: "Browse",
	uploadSingleFile: "You are allowed to upload a single file.",
	acceptableFileTypes: "Acceptable file types: <bold>json</bold> & <bold>csv</bold>",
	fileReady: "File is ready to submit",
	additionalInformation: "Additional Information",
	referenceId: "Reference ID",
	includeAttachments: "Include Attachments",
	filesToBeAttached: "The files to be attached can be in <bold>.pdf</bold> or <bold> .doc</bold> or <bold> .docx</bold> or <bold> .tt</bold>  type",
	noFilesAttach: "There are no files to attach.",
	dropFile: "Drop your files or ",
	requiredCounter: "{{count}} out of {{total}} required files have been uploaded", //1 out of 3 required files have been uploaded
	requiredUploaded: "All required files have been uploaded",


	//Alert
	uploadWrongFile: "You uploaded the wrong file format.",
	unexpectedError: "Unexpected error",
	cantUpload: "We can't upload your data. ",
	viewErrorMessage: "View error message",
	item: "Item",

	//Shared Data Success Page
	dataFileShared: "We are now processing your request.",
	dataFileSharedMessage: "You can check your request status by clicking the “Data Process Status” button below",
	backToSharedData: "Data Process Status",

	//Request Data Success Page
	dataFileRequested: "Data File has been requested",
	dataFileRequestedMessage: "The data will be made available after processing.",
	backToReceivedData: "Back to Received Data",

	//Share/Request Data Fail Page
	somethingWrong: "Something went wrong",
	somethingWrongSharingMessage: "Please try sharing your data again",
	somethingWrongRequestingMessage: "Please try requesting your data again",
	tryAgain: "Try again",
	fail: "Fail",

	//Received Data Page
	notConsumerError: "Based on your config, you are not consuming any data elements.",
	requestData: "Request Data",

	//Received Data Download Page
	fromDate: "from date",
	toDate: "to date",
	noResult: "No Result",
	attachment: "Attachment",
	downloadJSON: "Download JSON",
	downloadCSV: "Download CSV",
	incorrectDate: "From date should not be greater than to date",

	//Request Data Page
	dataInformation: "Data Information",
	cannotRequestData: "We cannot request your data",
	fillInAllFields: "Please fill in all required fields",
	chooseDataElementToRetrieve: "Choose which data element you want to retrieve:",
	chooseWhomToRetrieved: "Choose whom you want to retrieve your data from:",

	//My Activity Page
	filter: "Filter",
	event: "Event",
	via: "Via",
	message: "Message",
	view: "View",

	//Configuration
	configuration: "Configuration",
	save: "Save",
	cancel: "Cancel",
	licenseKey: "License Key",
	connectionType: "Connection Type",
	host: "Host",
	username: "Username",
	password: "Password",
	databaseName: "Database Name",
	databasePort: "Database Port",
	queueType: "Queue Type",
	uRL: "URL",
	sourceConfig: "Source Config",

	//API Configuration
	apiConfiguration: "API Configuration",
	sourceToPitstop: "Source System to Pitstop",
	pitstopToSource: "Pitstop to Source System",
	addAPI: "Add API Configuration",
	selectConfigurationType: "Select Configuration Type",
	selectAuthMethod: "Select Authentication Method",
	emptypitstopToSource: "There's no configuration for this yet.",
	addProvideAPI: "Add Provide API",
	addReceiveAPI:"Add Receive API",
	addNotifyAPI:"Add Notify API",
	sendingToPitstop: "Sending to Pitstop",
	sendingToSourceSystem: "Sending to Source System",

	//Installation
	almostUp: "You're almost all set up",
	verifiedLicence: "Your license has been verified",
	enterLicense: "Enter your company's license key to complete set up",
	allDone: "All done! You can now launch the Pitstop Portal and log in.",
	register: "Register",
	cantFindKey: "Can't find your registration license key?",
	contactUs: "Contact us.",
	licenseRegistered: "Licence registered for:",
	launchPitstop: "Launch Pitstop Portal",

	// Data Setting
	dataSetting: "Data Settings",
	copy: "Copy",

	// Forward
	inputDataInformation: "Input data information",
	forwardData: "Forward Data",
	chooseWhoToSend: "Choose who you would like to send this to",
	dataForwardShared: "Data has been forwarded successfully",
	dataForwardSharedMessage: "Refer to Shared Data to view details of the transaction.",

	// Eclip
	myEclip: "My Packages",
	backToMyEclip: 'Back to My Packages',
	backToSharedWithMe: 'Back to Shared With Me',
	backTo: 'Back to',
	sharedWithMe: "Shared With Me",
	pecentageOfCompletion: "Percentage of completion",
	template: "Template",
	templates: "Templates",
	createEclipTitle: "Create Package",
	eclipName: "Name of Package",
	eclipNamePlaceholder: "Enter name",
	eclipReference: "Reference number",
	eclipReferencePlaceholder: "Enter reference number",
	eclipMessagePlaceholder: "Type your message here",
	eclipParticipant: "Select Participant",
	eclipDataElements: "Data Elements",
	eclipReferenceDescription: "You will be using this to search for this package. We suggest you use a recognisable reference ID that is already used within your organisation.",
	eclipTemplate: 'Select Template',
	eclipExpectedDate: 'Expected Date of Completion',
	eclipExpectedDatePlaceholder: 'Date',
	eclipRequestMoreDescription: 'Describe the documents that you need or the information that is insufficient. This will help your counter party react to this request swiftly. ',
	requiredDataElements: 'Data Elements',
	referenceNumberDescription: 'You will be using this to search for this package. We suggest you use a recognisable reference ID that is already used within your organisation.',
	intendedReceipient: 'Intended Recipient',
	packageOwner: 'Package Owner',
	structuredData: 'Structured Data',
	provideOnBehalfOf: 'Provide On Behalf Of',
	attachments: 'Attachments',
	addAttachment: 'Add Attachment +',
	addRecipient: 'Add Recipient',
	changeRecipient: 'Change Recipient',
	confirmSend: 'Send Package Confirmation',
	activityLog: 'Activity Log',

	READY_TO_SEND: 'Ready to send',
	SENT: 'Sent',
	NEW_DATA_RECEIVED: 'New data received',
	REQUESTED: 'More information required',
	DELIVERY_FAILED: 'Ready to send',
	DELIVERED: 'Delivered',
	MORE_INFORMATION_REQUIRED: 'More information required',
	PACKAGE_REQUESTED: 'Package requested',
	PACKAGE_ACCEPTED: 'Accepted',
	PACKAGE_DECLINED: 'Declined',

	lastModifiedOn: 'Last Modified On',
	creadtedOn: 'Created On',
	expectedCompletionDate: 'Expected Completion Date',

	receiving: 'Receiving',
	returning: 'Returning',

	requestor: 'Requestor',
	decline: 'Decline',

	//Trade Trust Record Transfer
	e_tranferrable_record :'E-Transferable Record',
	dropRecordTransferData: "Drop your TradeTrust file or ",



};
